module.exports = __webpack_public_path__ + "/images/mockup-llista-fr-no-fondo.d2a24ce.png";